module.exports = __webpack_public_path__ + "img/symbol_5.48527f2b.png";